module.exports = __webpack_public_path__ + "img/49.73b9ead4.png";